/* eslint-disable max-len */
import type { IconMappingType } from './FeatureIconsLookup';

// DS Icons
// Lookup Page: https://storybook.nespresso.com/icons/
// Icon Index:  node_modules/@nespresso-design-system/assets/dist/api/icons/index.json
// Repo:        https://dsu-bitbucket.nestle.biz/projects/DSNES/repos/assets/browse/packages/icons/src/24/cupsize
// Note: Cupsize icons are exclusive to OL or VL technology

// DS Icon JSON paths for icon data are like this:
//
// Cupsizes: "24|32"."cupsize"."*"
// Recipes: "24|32"."recipe"."*"

// Example DS Json objects:
//
// CUPSIZE
// "cupsize-espresso-ol": {
//   "name":"cupsize-espresso-ol",
//   "prop":"32/cupsize/cupsize-espresso-ol",
//   "path":"/shared_res/agility/next-components/assets/icons/32/cupsize/cupsize-espresso-ol"
// }
//
// In ECAPI, the supercategories array contains cup size, and other data.

// The below is a map between ECAPI category and the DS ID
// @todo - do this on the backend, or in the DS?

// prettier-ignore
const cupSizes: IconMappingType[] = [
  // ORIGINAL
  { supId: 'capsule-cupsize-ristretto', type: 'cupsize', dsId: 'cupsize-ristretto-ol', mlCoffee: 25 },
  { supId: 'capsule-cupsize-espresso', type: 'cupsize', dsId: 'cupsize-espresso-ol', mlCoffee: 40 },
  { supId: 'capsule-cupsize-lungo', type: 'cupsize', dsId: 'cupsize-lungo-ol', mlCoffee: 110 },
  { supId: 'capsule-cupsize-lungo-plus', type: 'cupsize', dsId: 'cupsize-lungo-plus-ol', mlCoffee: 150 }, // same volume as Gran Lungo
  // VERTUO
  { supId: 'capsule-cupsize-ristretto-vertuo', type: 'cupsize', dsId: 'cupsize-ristretto-vl', mlCoffee: 25 },
  { supId: 'capsule-cupsize-espresso-vertuo', type: 'cupsize', dsId: 'cupsize-espresso-vl', mlCoffee: 40 },
  // { supId: 'capsule-cupsize-lungo-vertuo', type: 'cupsize', dsid: 'cupsize-lungo-vl', mlCoffee: 110 }, // THIS DOES NOT EXIST IN HMC!
  { supId: 'capsule-cupsize-double-espresso-vertuo', type: 'cupsize', dsId: 'cupsize-lungo-vl', mlCoffee: 80 }, // still supported category name, mapped to lungo-vl icon
  { supId: 'capsule-cupsize-gran-lungo', type: 'cupsize', dsId: 'cupsize-gran-lungo-vl', mlCoffee: 150 },
  { supId: 'capsule-cupsize-coffee', type: 'cupsize', dsId: 'cupsize-mug-small-vl', mlCoffee: 230 }, // this ought to be called: cupsize-mug-small-vl but it's not!
  { supId: 'capsule-cupsize-carafe-vertuo', type: 'cupsize', dsId: 'cupsize-carafe-vl', mlCoffee: 535 },
  { supId: 'capsule-cupsize-mug-medium', type: 'cupsize', dsId: 'cupsize-mug-medium-vl', mlCoffee: 490 },
  { supId: 'capsule-cupsize-mug-large', type: 'cupsize', dsId: 'cupsize-mug-large-vl', mlCoffee: 590 },
  // OTHER
  { supId: 'capsule-cupsize-large-americano-ol', type: 'cupsize', dsId: 'cupsize-large-americano-ol', mlCoffee: 200 }, // added just in case
  { supId: 'capsule-cupsize-americano', type: 'cupsize', dsId: 'cupsize-americano-ol', mlCoffee: 150 },
  // OTHER EXISTING CATEGORIES WITH NO OFFICIAL MAPPING...
  { supId: 'capsule-cupsize-ristretto-b2b', type: 'cupsize', dsId: 'cupsize-ristretto-ol', mlCoffee: 25 }, // MAP TO RISTRETTO
  { supId: 'capsule-cupsize-espresso-b2b', type: 'cupsize', dsId: 'cupsize-espresso-ol', mlCoffee: 40 }, // MAP TO ESPRESSO
  { supId: 'capsule-cupsize-lungo-b2b', type: 'cupsize', dsId: 'cupsize-lungo-ol', mlCoffee: 110 }, // MAP TO LUNGO
  // SPECIAL CASE
  { supId: 'capsule-cupsize-xl', type: 'accessory', dsId: 'travel-mug-vl', mlCoffee: 355 },
  { supId: 'capsule-cupsize-alto', type: 'accessory', dsId: 'travel-mug-vl', mlCoffee: 355 },
  { supId: 'capsule-cupsize-ccm-80ml', type: 'machine', dsId: 'coffee-creations', mlCoffee: 80 },
  { supId: 'capsule-cupsize-ccm-40ml', type: 'machine', dsId: 'coffee-creations', mlCoffee: 40 },
  { supId: 'capsule-cupsize-ccm-25ml', type: 'machine', dsId: 'coffee-creations', mlCoffee: 25 },
];
export default cupSizes;
